<template>
  <div class="anc-container">
    <div class="announcement" v-for="(a, i) in listOfAnnouncements" :key="i">
      <div class="ann-title"> {{ a.title }} </div>
      <div class="ann-body" v-html="a.body"></div>
    </div>
  </div>
</template>

<script>
import appConfig from '@/app.config';
import { announcementsPublicApi } from '../services/announcements-api';

export default {
  name: 'Announcements',
  data() {
    return {
      updateCheckerRef: null,
      listOfAnnouncements: [],
    };
  },
  computed: {
  },
  methods: {
    checkForUpdates() { // todo: create a global service to for a timer, and subscribe
      const self = this;
      return setInterval(async () => {
        try {
          self.loadAnnouncements();
        } catch (err) {
          console.error(err);
        }
      }, appConfig.frequencyToCheckServerForUpdates * 60 * 1000);
    },
    turnOffUpdateChecker(interval) {
      if (interval) clearInterval(interval);
    },
    async loadAnnouncements() {
      this.listOfAnnouncements = await announcementsPublicApi.getAnnouncements();
    },
  },

  async created() {
    this.loadAnnouncements();
    this.updateCheckerRef = this.checkForUpdates();
  },
  beforeDestroy() {
    this.turnOffUpdateChecker(this.updateCheckerRef);
  },
};
</script>

<style>

.announcement {
    padding: 15px 25px;
    box-shadow: 1px 1px 4px 0px #d3ad90;
    margin-top: 5px;
    border-radius: 3px;
    font-size: 14px;
    background: #fffed2;
    margin-bottom: 10px;
}
.ann-title {
    font-weight: 600;
    color: #c93204;
    margin-bottom: 5px;
}
.ann-body {
    text-align: justify;
}

</style>
